<template>
  <div ref="fotoPortadaRef" class="fotoportada-container">
    <div class="overlay">
      
      <!-- SECCIÓN SUPERIOR: Gráficos -->
      <div class="top-graphics-wrapper">
        <img
          ref="circuloRef"
          src="@/assets/circuuu.png"
          alt="Rose Circle"
          class="circulo-img"
        >
        <img
          ref="quinceaneraRef"
          src="@/assets/quincee.png"
          alt="Quinceañera"
          class="quinceanera-img"
        >
      </div>

      <!-- SECCIÓN CORTE DE HONOR -->
      <div ref="corteRef" class="corte-seccion">
        <h3 class="corte-titulo">Corte de Honor</h3>
        
        <div class="subseccion-corte">
          <h4 class="subtitulo-corte">Chambelán de Honor</h4>
          <p class="nombre-destacado">Jesús Navejar</p>
        </div>

        <div class="grid-corte">
          <div class="columna-corte">
            <h4 class="subtitulo-corte">Chambelanes</h4>
            <ul class="lista-simple">
              <li>Gabriel Vega</li>
              <li>Benjamin Rodriguez</li>
              <li>Ethan Navejar</li>
            </ul>
          </div>

          <div class="columna-corte">
            <h4 class="subtitulo-corte">Damas</h4>
            <ul class="lista-simple">
              <li>Leilani Vega</li>
              <li>Madison Navejar</li>
              <li>Sherlyn Mercado</li>
            </ul>
          </div>
        </div>
      </div>

      <!-- SECCIÓN PADRINOS -->
      <div ref="padrinosSeccionRef" class="corte-seccion">
        <h3 class="corte-titulo">Padrinos</h3>
        <p class="padrinos-mensaje">
          Les agradecemos de todo corazón por acompañarnos y ser una parte fundamental en este día tan especial.
        </p>

        <!-- BOTÓN PARA ABRIR OVERLAY DE PADRINOS -->
        <button class="btn-padrinos" @click="abrirPadrinos">
          Ver Mis Padrinos
        </button>
      </div>

    </div>

    <!-- 🌟 MODAL ABSOLUTO POSICIONADO AL SCROLL ACTUAL -->
    <Teleport to="body">
      <Transition name="fade-modal">
        <div 
          v-if="mostrarPadrinos" 
          class="modal-overlay" 
          :style="{ top: modalTopPosition + 'px' }"
          @click.self="cerrarPadrinos"
        >
          <div class="modal-content">
            <!-- Botón para cerrar -->
            <button class="close-btn" @click="cerrarPadrinos">&times;</button>

            <h3 class="modal-titulo">Mis Padrinos</h3>
            <p class="modal-subtitulo">
              Les agradecemos de todo corazón por acompañarnos y ser una parte fundamental en este día tan especial.
            </p>

            <div class="padrinos-lista-elegante">
              <!-- PADRINOS DE HONOR DESTACADOS -->
              <div class="padrino-item padrino-honor">
                <span class="padrino-concepto">Padrinos de Honor</span>
                <span class="padrino-nombre">Ponciano Vega y Nilda Vega</span>
              </div>

              <div class="padrino-item">
                <span class="padrino-concepto">Ceremonia de Bendición</span>
                <span class="padrino-nombre">Ponciano & Nilda Vega</span>
              </div>

              <div class="padrino-item">
                <span class="padrino-concepto">Ramo Natural</span>
                <span class="padrino-nombre">Guillermo y Hermina Vega</span>
              </div>

              <div class="padrino-item">
                <span class="padrino-concepto">Ramo de Recuerdo</span>
                <span class="padrino-nombre">Ramiro & Brenda Basurto</span>
              </div>

              <div class="padrino-item">
                <span class="padrino-concepto">Libro de Oración y Rosario</span>
                <span class="padrino-nombre">Crystal Vega</span>
              </div>

              <div class="padrino-item">
                <span class="padrino-concepto">Biblia</span>
                <span class="padrino-nombre">Cesar & Erica Navejar</span>
              </div>

              <div class="padrino-item">
                <span class="padrino-concepto">Crucifijo</span>
                <span class="padrino-nombre">Andres Marroquin</span>
              </div>

              <div class="padrino-item">
                <span class="padrino-concepto">Cojín de Arrodillarse</span>
                <span class="padrino-nombre">Leilani Vega</span>
              </div>

              <div class="padrino-item">
                <span class="padrino-concepto">Tiara</span>
                <span class="padrino-nombre">Eddie & Liset Saragoza</span>
              </div>

              <div class="padrino-item">
                <span class="padrino-concepto">Zapatillas</span>
                <span class="padrino-nombre">Silvia Vega</span>
              </div>

              <div class="padrino-item">
                <span class="padrino-concepto">Recuerdos / Souvenirs</span>
                <span class="padrino-nombre">Valerie Zaragoza & Emily Vega</span>
              </div>

              <div class="padrino-item">
                <span class="padrino-concepto">Regalo Sorpresa</span>
                <span class="padrino-nombre">Jesús Navejar</span>
              </div>

              <div class="padrino-item">
                <span class="padrino-concepto">Regalo Sorpresa</span>
                <span class="padrino-nombre">Servando Vega</span>
                <span class="padrino-nombre">Angel Navejar</span>
              </div>

              <div class="padrino-item">
                <span class="padrino-concepto">Última Muñeca</span>
                <span class="padrino-nombre">Lydia & Cesar Navejar</span>
              </div>

              <div class="padrino-item">
                <span class="padrino-concepto">Oso de Peluche</span>
                <span class="padrino-nombre">Silvia Vega</span>
              </div>

              <div class="padrino-item">
                <span class="padrino-concepto">Anillo</span>
                <span class="padrino-nombre">Samuel & Caitlin Torres</span>
              </div>

              <div class="padrino-item">
                <span class="padrino-concepto">Esclava de Identidad</span>
                <span class="padrino-nombre">Jose & Maria Vega</span>
              </div>

              <div class="padrino-item">
                <span class="padrino-concepto">Medalla</span>
                <span class="padrino-nombre">Jesus & Ruth Vega</span>
              </div>

              <div class="padrino-item">
                <span class="padrino-concepto">Aretes</span>
                <span class="padrino-nombre">Omar & Leslie Vega</span>
              </div>

              <div class="padrino-item">
                <span class="padrino-concepto">Álbum de Fotos</span>
                <span class="padrino-nombre">Eric & Annabel Navejar</span>
              </div>

              <div class="padrino-item">
                <span class="padrino-concepto">Libro de Firmas</span>
                <span class="padrino-nombre">Silvia Vega</span>
              </div>

              <div class="padrino-item">
                <span class="padrino-concepto">Brindis</span>
                <span class="padrino-nombre">Jesus & Vanesa Vega</span>
              </div>

              <div class="padrino-item">
                <span class="padrino-concepto">Set de Pala y Cuchillo para Pastel</span>
                <span class="padrino-nombre">Ivonne Vega</span>
              </div>
            </div>
          </div>
        </div>
      </Transition>
    </Teleport>

  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import gsap from 'gsap'

export default {
  name: 'InvitacionQuinceanera',
  setup() {
    const fotoPortadaRef = ref(null)
    const circuloRef = ref(null)
    const quinceaneraRef = ref(null)
    const corteRef = ref(null)
    const padrinosSeccionRef = ref(null)

    // Estado para controlar la visibilidad y posición del modal
    const mostrarPadrinos = ref(false)
    const modalTopPosition = ref(0)

    const abrirPadrinos = () => {
      // Capturamos exactamente a qué altura está scrolleada la ventana en este momento
      modalTopPosition.value = window.scrollY || document.documentElement.scrollTop
      mostrarPadrinos.value = true
      document.body.style.overflow = 'hidden'
    }

    const cerrarPadrinos = () => {
      mostrarPadrinos.value = false
      document.body.style.overflow = ''
    }

    onMounted(() => {
      gsap.from(fotoPortadaRef.value, { 
        opacity: 0, 
        y: 80, 
        duration: 1.4, 
        ease: 'power3.out' 
      })

      const tl = gsap.timeline({ delay: 0.8 });

      tl.fromTo(
        circuloRef.value, 
        { opacity: 0, y: -150, scale: 1.8, filter: 'blur(15px)' }, 
        { opacity: 1, y: 0, scale: 1, filter: 'blur(0px)', duration: 1.8, ease: 'power4.out' }, 
        0
      );

      tl.from(
        quinceaneraRef.value, 
        { opacity: 0, y: 50, duration: 1.5, ease: 'power3.out' }, 
        0.8
      );

      tl.from(
        corteRef.value,
        { opacity: 0, y: 40, duration: 1.2, ease: 'power3.out' },
        1.3
      );

      tl.from(
        padrinosSeccionRef.value,
        { opacity: 0, y: 40, duration: 1.2, ease: 'power3.out' },
        1.6
      );
    })

    return {
      fotoPortadaRef,
      circuloRef,
      quinceaneraRef,
      corteRef,
      padrinosSeccionRef,
      mostrarPadrinos,
      modalTopPosition,
      abrirPadrinos,
      cerrarPadrinos
    }
  }
}
</script>

<style scoped>
/* ==========================================
   1. ESTILOS BASE Y CONTENEDORES
   ========================================== */
.fotoportada-container {
  position: relative;
  width: 100%;
  min-height: 100vh;
  overflow: visible;
  background-color: transparent;
  margin-top: -60px;
  background-repeat: no-repeat;
  background-position: center bottom;
  z-index: 1;
}

.overlay {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 40px 20px 80px 20px;
  z-index: 2;
}

/* ==========================================
   2. GRÁFICOS SUPERIORES
   ========================================== */
.top-graphics-wrapper {
  position: relative;
  width: 100%;
  max-width: 500px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;
  z-index: 3;
}

.circulo-img {
  width: 100%;
  max-width: 550px;
  height: auto;
  position: relative;
  z-index: 1;
}

.quinceanera-img {
  width: 70%;
  max-width: 460px;
  height: auto;
  position: absolute;
  top: 55%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: -1;
}

/* ==========================================
   3. SECCIÓN CORTE DE HONOR Y PADRINOS
   ========================================== */
.corte-seccion {
  width: 100%;
  max-width: 550px;
  margin-top: 40px;
  text-align: center;
  z-index: 4;
}

.corte-titulo {
  font-family: 'Playfair Display', serif;
  font-size: 25px;
  font-weight: 800;
  letter-spacing: 2.5px;
  text-transform: uppercase;
  color: #B28F60;
  margin-bottom: 18px;
  position: relative;
  display: inline-block;
  padding-bottom: 8px;
}

.subseccion-corte {
  margin-bottom: 20px;
}

.subtitulo-corte {
  font-family: 'Playfair Display', serif;
  font-size: 15px;
  font-weight: 800;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  color: #7a5e3d;
  margin-bottom: 6px;
}

.nombre-destacado {
  font-family: 'Playfair Display', serif;
  font-size: 19px;
  font-weight: 700;
  color: #8c88e6;
  margin: 0;
}

.grid-corte {
  display: flex;
  justify-content: space-around;
  gap: 20px;
  margin-bottom: 25px;
  flex-wrap: wrap;
}

.columna-corte {
  flex: 1;
  min-width: 140px;
}

.lista-simple {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.lista-simple li {
  font-family: 'Playfair Display', serif;
  font-size: 16px;
  font-weight: 700;
  color: #7b61d4;
}

.padrinos-mensaje {
  font-family: 'Playfair Display', serif;
  font-size: 14px;
  font-style: italic;
  font-weight: 600;
  color: #7a5e3d;
  margin-bottom: 15px;
  padding: 0 15px;
  line-height: 1.4;
}

/* ==========================================
   4. BOTÓN PADRINOS
   ========================================== */
.btn-padrinos {
  margin-top: 15px;
  padding: 12px 30px;
  background-color: #a3a1f0;
  color: #ffffff;
  border: none;
  border-radius: 30px;
  font-family: 'Playfair Display', serif;
  font-size: 15px;
  font-weight: 800;
  letter-spacing: 2px;
  text-transform: uppercase;
  cursor: pointer;
  box-shadow: 0 4px 14px rgba(163, 161, 240, 0.5);
  transition: all 0.3s ease;
}

.btn-padrinos:hover {
  transform: translateY(-2px);
  background-color: #8e8ce6;
  box-shadow: 0 6px 18px rgba(163, 161, 240, 0.7);
}
</style>

<!-- ESTILOS GLOBALES: Corregido el punto y coma en color -->
<style>
.modal-overlay {
  position: absolute !important;
  left: 0 !important;
  width: 100vw !important;
  height: 100vh !important;
  background-color: rgba(0, 0, 0, 0.75) !important;
  backdrop-filter: blur(5px) !important;
  -webkit-backdrop-filter: blur(5px) !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  z-index: 9999999 !important;
  padding: 16px !important;
  box-sizing: border-box !important;
}

.modal-content {
  background: #adabf2 !important;
  width: 100% !important;
  max-width: 500px !important;
  max-height: 80vh !important;
  overflow-y: auto !important;
  -webkit-overflow-scrolling: touch !important;
  border-radius: 20px !important;
  padding: 35px 25px 30px 25px !important;
  position: relative !important;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.4) !important;
  text-align: center !important;
  color: #ffffff !important;
  box-sizing: border-box !important;
  margin: auto !important;
  
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.7) rgba(0, 0, 0, 0.15);
}

.modal-content::-webkit-scrollbar {
  width: 8px;
}

.modal-content::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.15);
  border-radius: 10px;
}

.modal-content::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.7);
  border-radius: 10px;
}

.close-btn {
  position: absolute !important;
  top: 15px !important;
  right: 20px !important;
  background: transparent !important;
  border: none !important;
  font-size: 28px !important;
  color: #ffffff !important;
  cursor: pointer !important;
  line-height: 1 !important;
}

.modal-titulo {
  font-family: 'Playfair Display', serif !important;
  font-size: 26px !important;
  font-weight: 800 !important;
  letter-spacing: 2.5px !important;
  text-transform: uppercase !important;
  color: #ffffff !important;
  margin-bottom: 10px !important;
}

.modal-subtitulo {
  font-family: 'Playfair Display', serif !important;
  font-size: 13px !important;
  font-style: italic !important;
  font-weight: 600 !important;
  color: #ffffff !important;
  margin-bottom: 25px !important;
  line-height: 1.4 !important;
}

.padrinos-lista-elegante {
  display: flex !important;
  flex-direction: column !important;
  gap: 16px !important;
}

.padrino-item {
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  padding-bottom: 12px !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.35) !important;
}

.padrino-item:last-child {
  border-bottom: none !important;
}

.padrino-honor {
  background: rgba(255, 255, 255, 0.15) !important;
  padding: 12px 10px !important;
  border-radius: 12px !important;
  border-bottom: none !important;
}

.padrino-concepto {
  font-family: 'CynthiaJuneJF', 'Playfair Display', serif !important;
  font-size: 32px !important;
  font-weight: 600 !important;
  letter-spacing: 2px !important;
  color: #ffffff !important;
  margin-bottom: 2px !important;
}

.padrino-nombre {
  font-size: 20px !important;
  font-family: 'Playfair Display', serif !important;
  font-weight: 700 !important;
  color: #312854 !important;
}

.fade-modal-enter-active,
.fade-modal-leave-active {
  transition: opacity 0.3s ease !important;
}

.fade-modal-enter-from,
.fade-modal-leave-to {
  opacity: 0 !important;
}
</style>